'use client';

import { FC } from 'react';

import { PLAN_CARD_TEST_ID } from './constants';
import { PlanCardModel } from './model';
import { Body, Card, Footer, Header, PriceSection } from './PlanCard.styles';
import { Badge } from './private-components/Badge';
import { CallToAction } from './private-components/CallToAction';
import { Cap } from './private-components/Cap';
import { ContractSummary } from './private-components/ContractSummary';
import { DescriptionList } from './private-components/DescriptionList';
import { DetailsList } from './private-components/DetailsList';
import { OldPrice, Price } from './private-components/PriceTag';
import { SubTitle } from './private-components/SubTitle';
import { Title } from './private-components/Title';

export const PlanCard: FC<PlanCardModel.CardProps> = ({ isNegative, cap, header, body, footer }) => (
    <Card data-test={PLAN_CARD_TEST_ID.CARD}>
        <Cap text={cap?.text} variant={cap?.variant} icon={cap?.icon} image={cap?.image} />
        <Body $negative={isNegative}>
            <Header>
                <SubTitle tag={header.subtitleTag} isNegative={isNegative}>
                    {header?.subtitle}
                </SubTitle>
                <Badge text={header.badge?.text} variant={header.badge?.variant} isNegative={isNegative} />
                <Title isNegative={isNegative} oldTitle={header.oldTitle} data-test={PLAN_CARD_TEST_ID.TITLE}>
                    {header.title}
                </Title>
            </Header>
            <DetailsList isNegative={isNegative} details={body.details} />
            {body.campaign?.(isNegative)}
            <PriceSection>
                <OldPrice isNegative={isNegative}>{body.oldPrice}</OldPrice>
                <Price isNegative={isNegative} isNewPrice={!!body.oldPrice}>
                    {body.price}
                </Price>
                <ContractSummary contractSummary={body.contractSummary} isNegative={isNegative} />
                <CallToAction isNegative={isNegative} callToAction={body.callToAction} />
            </PriceSection>
        </Body>
        <Footer data-test={PLAN_CARD_TEST_ID.FOOTER}>
            <DescriptionList
                title={footer.title}
                descriptions={footer.descriptions}
                isForcedExpanded={footer.isForcedExpanded}
                onExpandChange={footer.onExpandChange}
            />
        </Footer>
    </Card>
);
